import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class ComboService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/combo';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }


    getBrandList(): Promise<any> {
        const url = `${this.Url}/getBrandList`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getstyleList(): Promise<any> {
        const url = `${this.Url}/getStyleList`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getqualityList(): Promise<any> {
        const url = `${this.Url}/getQualityList`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getfitList(): Promise<any> {
        const url = `${this.Url}/getFitList`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    gettypeList(): Promise<any> {
        const url = `${this.Url}/getTypeList`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getDesignCombo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

        /*const url = `${this.Url}/getDesignCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);*/
    }
    getPoDhotiNoList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getPoDhotiNoList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
getCurrentSeason(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getCurrentSeason`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }
    getNewDesignCombo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getNewDesignCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

        /*const url = `${this.Url}/getDesignCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);*/
    }
    getCoreDesignCombo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getCoreDesignCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

        /*const url = `${this.Url}/getDesignCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);*/
    }

    getDesignComboColor(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignComboColor`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }
    getSeason(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSeason`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }

    getBrandNewSeason(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getBrandNewSeason`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }

    getdesignno(): Promise<any> {
        const url = `${this.Url}/getDesignNoList`;
        return this.http
            .post(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getSalesParty(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSalesParty`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }

    getSalesInvoiceReturnNo(color: any): Promise<any> {
        const url = `${this.Url}/getSalesInvoiceReturnNo`;
        return this.http
            .post(url, $.param(color), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    designNo(color: any): Promise<any> {
        const url = `${this.Url}/designNo`;
        return this.http
            .post(url, $.param(color), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getdesigncolor(color: any): Promise<any> {
        const url = `${this.Url}/getDesignColorList`;
        return this.http
            .post(url, $.param(color), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }



    
   
   
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/combo.service.ts